import React from 'react'

import CurrencyTextField from '@unicef/material-ui-currency-textfield'
import { FieldTitle, useInput, InputHelperText } from 'react-admin'

export const CurrencyInternalInput = ({
  label,
  format,
  helperText,
  onBlur,
  onFocus,
  onChange,
  options,
  parse,
  resource,
  source,
  validate,
  ...rest
}) => {
  const {
    id,
    input,
    isRequired,
    meta: { error, touched },
  } = useInput({
    format,
    onBlur,
    onFocus,
    onChange,
    parse,
    resource,
    source,
    type: 'text',
    validate,
    ...rest,
  })

  const handleKeyDown = (event) => {
    if (event.key === ',') {
      event.target.value += '.'
      event.preventDefault()
    }
  }

  return (
    <CurrencyTextField
      id={id}
      variant="filled"
      currencySymbol="USD"
      {...input}
      label={
        label !== '' &&
        label !== false && (
          <FieldTitle
            label={label}
            source={source}
            resource={resource}
            isRequired={isRequired}
          />
        )
      }
      minimumValue={0}
      error={!!(touched && error)}
      helperText={
        <InputHelperText
          touched={touched}
          error={error}
          helperText={helperText}
        >
          {error}
        </InputHelperText>
      }
      onChange={onChange}
      onKeyDown={handleKeyDown}
      {...options}
      {...rest}
    />
  )
}
